import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ISaveDeleteResponse } from '../Shared/interface';
import { UserService } from '../services/user.service';
import { UserSessionService } from '../services/usersession.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from '../services/modal-wrapper.service';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { EmitType } from '@syncfusion/ej2-base';
import { FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { Query } from '@syncfusion/ej2-data';
import { CacheService } from '../services/cache.service';
import { DataService } from '../facilityOperations/facOps-dashboard/data.service';
import { CallScriptService } from '../services/call-script.service';
@Component({
    selector: 'app-switch-store',
    templateUrl: './switch-store.component.html',
    styleUrls: ['./switch-store.component.scss'],
    standalone: false
})
export class SwitchStoreComponent implements OnInit {
  modalRef: BsModalRef;
  switchData;
  tempNav;
  private storeDropdownWasOpened = false;
  @Input() storeList;
  @Input() lastAccessed;
  @Output() storeChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('template1', { static: true }) switchstorepopup: TemplateRef<any>;
  @ViewChild('template', { static: true }) alertpopup: TemplateRef<any>;
  defaultStoreName: any;

  constructor(private userService: UserService,
    public authService: MsalService,
    private userSessionService: UserSessionService,
      private modalWrapper: ModalWrapperService,
    private router: Router,
    private cacheService: CacheService,
    private data: DataService,
    private callScriptService: CallScriptService) { }

  ////Drop Down changes
  // maps the appropriate column to fields property
  public fields: Object = { text: 'Name', value: 'Id' };
  // set the height of the popup element
  public height: string = '220px';
  // set the placeholder to DropDownList input element
  public watermark: string = 'Select a store';
  // set the placeholder to filter search box input element
  public filterPlaceholder: string = 'Search';
  // filtering event handler to filter a Country
  public onFiltering: EmitType<FilteringEventArgs> = (e: FilteringEventArgs) => {
    let query: Query = new Query();
    //frame the query based on search string with filter type.
    query = (e.text !== '') ? query.where('Name', 'contains', e.text, true) : query;
    //pass the filter data source, filter query to updateData method.
    e.updateData(this.storeList, query);
  }

  ngOnInit() {
    this.tempNav = this.router;
    this.lastAccessed = this.lastAccessedStore;
    if (!this.lastAccessed) { this.lastAccessed = 0; }
  }

  saveChangedLocation() {
    this.cacheService.clearCacheTables('api-store').subscribe(() => {
      this.userService.SaveLastAccessedFacility(this.lastAccessed).subscribe((response: ISaveDeleteResponse) => {
      });
      this.lastAccessedStore = parseInt(this.lastAccessed);
      this.userSessionService.userSessionData.LastAccessedStoreId = this.lastAccessed;
      // Persist the selection so it survives a page refresh even if the
      // getLoggedInUserDetails API returns a stale/cached LastAccessedFacility.
      try { localStorage.setItem('ssm_last_facility', String(this.lastAccessed)); } catch (_) { }
      let facilityId = this.userSessionService.isCallcenterAgent ? 0 : this.userSessionService.userSessionData.LastAccessedStoreId;
      this.getAllCallScripts(facilityId);
      this.storeChanged.emit(this.lastAccessedStore);
      this.data.callGetNotficationCountEmitter.next(true);
      this.modalRef.hide();
      this.modalRef = null;
    });
  }

  getAllCallScripts(facilityId) {
    this.callScriptService.GetAllCallScriptDetails(facilityId).subscribe((response: []) => {
      if (response && response.length) {
        this.userSessionService.userSessionData.AllCallScriptData = response;
      } else {
        this.userSessionService.userSessionData.AllCallScriptData = [];
      }
    }, err => {
      this.userSessionService.userSessionData.AllCallScriptData = [];
    });
  }

  get lastAccessedStore() {
    return this.userSessionService.userSessionData.LastAccessedStoreId;
  }
  set lastAccessedStore(value) {
    this.userSessionService.userSessionData.LastAccessedStoreId = value;
  }

  openModal(template: TemplateRef<any>, animated: boolean = true) {
    this.storeDropdownWasOpened = false;
    const modalRef = this.modalWrapper.openTemplate(template, { class: "modal-dialog-centered", backdrop: 'static', keyboard: false, animated });
    this.modalRef = modalRef;
    modalRef.onHidden.subscribe((reason: any) => {
      const isCurrentModal = this.modalRef === modalRef;
      // Works around ngx-bootstrap misreading Syncfusion's history.back()-based popstate
      // (touch devices, filtering enabled) as back-navigation and wrongly closing this modal.
      const shouldReopen = isCurrentModal && reason === 'browser-back-navigation-clicked' && this.storeDropdownWasOpened;
      if (isCurrentModal) {
        this.modalRef = null;
      }
      if (shouldReopen) {
        this.openModal(template, false);
      }
    });
  }

  onDropdownOpen(): void {
    this.storeDropdownWasOpened = true;
  }

  openSwitchstoreModal() {
    if (!this.modalRef) {
      this.openModal(this.switchstorepopup);
    }
  }

  openemptystoreModel() {
    if (!this.modalRef) {
      this.openModal(this.alertpopup);
    }
  }

  cancelSwitchStore() {
    this.modalRef.hide();
    this.modalRef = null;
  }

  redirect() {
    this.authService.logout();
    this.modalRef.hide();
  }
}
